import { addEdgeLips, breakPath, glassFold, setDefaultStyle, smoothCorner } from "apparatus/draw";
import { DEFAULT_LIQUID_DATA, P, Segments } from "apparatus/library/common";
import { createTap, Tap } from "apparatus/library/common/tap";
import { Path } from "paper";
export class DeanStarTrap {
    render(appearance) {
        const bottomPart = [
            [[-10, 76]],
            [[-10, 150], , [0, 10]],
            [[-5, 200], [0, -40]],
            [[5, 200], , [0, -40]],
            [[10, 150], [0, 10]]
        ];
        const basicShape = new Path(Segments([[-10, 0]], [[-10, 57]], [[-107, 85]], [[-107, 142], , [-3, 0]], [[-105, 172]], [[-91, 172]], [[-89, 142], [3, 0]], [[-89, 99]], ...bottomPart, [[10, 0]]));
        const liquidMask = new Path(Segments(...bottomPart, [[10, 76]]));
        smoothCorner(basicShape.segments[8], 4);
        smoothCorner(basicShape.segments[7], 4);
        smoothCorner(basicShape.segments[2], 10);
        smoothCorner(basicShape.segments[1], 4);
        addEdgeLips(basicShape);
        const graphic = breakPath(basicShape, 8, 16);
        setDefaultStyle(graphic);
        // Add a glass fold at the T-junction.
        graphic.addChild(glassFold(-8, 67, { rotation: -90 }));
        // Add a tap.
        const tap = createTap(appearance);
        graphic.addChild(tap);
        tap.position = P(0, 165);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            liquidMask: liquidMask,
            pivot: basicShape.bounds.center,
            ignoreFlipping: [tap]
        };
    }
}
DeanStarTrap.properties = {
    label: "Dean-Stark Trap",
    canContainLiquids: true,
    flippable: true,
    defaultAppearance: Object.assign({}, Tap.defaultAppearance),
    appearanceSpecs: [
        Tap.appearanceSpec,
    ],
    defaultLiquidData: Object.assign(Object.assign({}, DEFAULT_LIQUID_DATA), { amountRatio: 0.75 })
};
